<!--模板界面-->
<template>
  <div class="jiemian">
    <!-- v-if="enable && !tianjin" -->
    <div class="topMenu" v-if="enable && !tianjin && !AirportTopMenuFlag">
      <div class="leftPart">
        <div :class="['leftPart-logo',{'leftPart-logo-active':isCollapse}]" :title="title" @click="logoPage">
          <span style="flex-shrink: 0;
              position: fixed; 
              margin-top: 37px;
               display: flex;
              align-items: center;z-index:1">
            <img v-if="newLogo.length != 0 && newLogo[0].systemName" :src="newLogo[0].logoInfo"
              :style="{'max-width':isCollapse ? '0.5rem': '1rem','max-height':'58px'}">
            <img v-if="newLogo.length != 0 && !newLogo[0].systemName" :src="newLogo[0].logoInfo"
              :style="{'max-width':isCollapse ? '0.5rem': '1.6rem','max-height':'58px'}">
            <span v-show="!isCollapse" class="unitName sidebar-title">{{newLogo.length == 0 ? ''
              :newLogo[0].systemName}}</span>
          </span>
        </div>
        <span>

          <div class="unitSelect flexCenter" style="position: relative;z-index: 9;">
            <div class="flexCenter" style="position: inherit;">
              <img src="../../../assets/unifyImg/expand.png" alt="" @click="isCollapse = false" v-if="isCollapse"
                style="width:20px;height:20px">
              <img src="../../../assets/unifyImg/retract.png" alt="" @click="isCollapse = true" v-else
                style="width:20px;height:20px">
              <div :class="['nowUnit-name',{'nowUnit-active':shouMenu}]" @click="shouMenu = true"
                @mouseleave="shouMenu = false">
                <span> {{nowUnit.name}}</span>
                <img src="../../../assets/arrowb.png" alt="">
              </div>
              <!---->
              <!-- <img :src="filterIco" alt="" style="width: .25rem;height: .25rem;cursor: pointer;" @click="filterName = undefined"> -->
            </div>
          </div>
          <div class="unitMenu" v-show="shouMenu" @mouseenter="shouMenu = true" @mouseleave="shouMenu = false">
            <elUnitTree></elUnitTree>
            <!-- :filterText='filterName' -->
          </div>
        </span>
        <div style="right: 30%;display: flex;align-items: center;margin-left:3px" class="now-area">
          <div :class="['nowUnit-name',{'nowUnit-active':areaTree}]" @click="areaTree = true"
            @mouseleave="areaTree = false">
            <span>{{nowArea}}</span>
            <img src="../../../assets/arrowb.png" alt="">
          </div>
          <div class="area-tree" v-show="areaTree" @mouseenter="areaTree = true" @mouseleave="areaTree = false">
            <elUnitTreeArea></elUnitTreeArea>
          </div>
        </div>
      </div>
      <!--title 从前端获取 -->
      <!-- <span v-if="companyTitle !=''" class="webTitle" >{{companyTitle}}</span> -->

      <!--title 从后台获取 -->
      <!-- <span v-else class="webTitle">{{title}}</span> -->
      <div class="rightPart">
        <div style="padding-right: .2rem;display: flex;align-items: center;" @click="bookmark_fn">
          <span style="color: #666666;margin-right:4px" class="zhuangtai">书签栏</span>
          <img src="../../../assets/unifyImg/open.png" alt="" class="tongyi-img" v-if="bookmark">
          <img src="../../../assets/unifyImg/close.png" alt="" class="tongyi-img" v-else>
        </div>
        <!-- <div style="padding-right: .2rem;display: flex;align-items: center;">
					<span style="color: #666666;margin-right:4px" class="zhuangtai">通讯状态</span>
					<img src="../../../assets/unifyImg/connect.png" alt="" class="tongyi-img" v-if="socketSate">
					<img src="../../../assets/unifyImg/break.png" alt="" class="tongyi-img" v-else>
				</div> -->
        <!--天气-->
        <p class="nowTimeBox">{{nowTime}}&nbsp;&nbsp;&nbsp;{{nowWeek}}</p>
        <div v-if="newweatherIsShow">
          <span v-if="cityWearter==undefined" style="color: #666666;" class="zhuangtai">无天气数据</span>
          <div v-if="cityWearter!=undefined"
            style="display: flex;align-items: center;justify-content: space-around;margin: 0px 2px 0px 12px;">
            <div style="display: flex;align-items:center;padding-right: .1rem;">
              <img class="tongyi-img" :src="weatherImg(cityWearter.weather)" />
              <span style="color: #666666;padding-left: .05rem;" class="zhuangtai">{{cityWearter.weather}}</span>
            </div>
            <div style="display: flex;align-items:center;">
              <span style="color: #666666;" class="zhuangtai">
                {{cityWearter.temperature}} ℃
              </span>
            </div>
            <div style="display: flex;align-items: center;padding-left: .1rem;">
              <span class="el-icon-location" style="color:#368ed9;font-size: 20px;"></span>
              <!-- <img :src="getResourcesByName('weather/dingwei.png')" /> -->
              <span style="color: #666666;padding-left: .05rem;padding-right: .1rem;"
                class="zhuangtai">{{cityWearter.city}}</span>
            </div>
          </div>
        </div>
        <img v-show="false" style="width: 25px;height: 25px;margin: 0 20px;cursor: pointer;position: relative;"
          @click="$emit('menuTypeChange')" :src="getResourcesByName('topMenu/changeMenuType.png')" alt="" />

        <div style="cursor: pointer;height: 48px;padding: 0 10px;position: relative;" class="flexCenter"
          @mouseenter="showMsg = true" @mouseleave="showMsg = false">
          <el-dropdown>
            <span class="el-dropdown-link">
              <img :src="getResourcesByName('topMenu/msg.png')" alt="" class="tongyi-img" title="最新消息"
                v-show="!showMsg">
              <img :src="getResourcesByName('topMenu/msgsel.png')" alt="" class="tongyi-img" title="最新消息"
                v-show="showMsg">
              <span class="existMsg" v-show="existMsg">{{unReadNum}}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div>
                <div class="btns">
                  <button @click="filterUnreadMsg" style="background: none;"
                    :class="{'isFilter':filterStatus}">未读消息</button>
                  <button @click="$router.push('/events')" class="isFilter">打开事件管理</button>
                </div>
                <div class="ul">
                  <div v-for="(e,i) in msgList" :key="i">
                    <div v-if="e.type == 'tips'" class="li">
                      <p style="text-align: center;line-height: 36px;border-bottom: dashed 1px #CCC;width: 100%;">
                        {{e.name}}</p>
                    </div>
                    <span v-else class="li">
                      <span class="l">【{{e.typeName}}】{{e.description}}</span> <span class="r" v-if="e.unReaded"
                        @click="markUnreadMsg(e)">已读</span>
                    </span>
                  </div>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <transition name="nomal-fade">
            <div v-show="showMsg" class="msgDialog">
              <div class="msgOperate">
                <button @click="filterUnreadMsg" :class="{'isFilter':filterStatus}">未读消息</button>
                <button @click="$router.push('/events')" class="isFilter">打开事件管理</button>
              </div>
              <listView :dataList="msgList" style="height: calc(100% - 50px);">
                <template v-slot:default="slotProps">
                  <div v-if="slotProps.item.type == 'tips'">
                    <p style="text-align: center;line-height: 36px;border-bottom: dashed 1px #CCCCCC;">
                      {{slotProps.item.name}}</p>
                  </div>
                  <div v-else class="unreadMsgInfo" :class="{'unReadMsg':slotProps.item.unReaded}">
                    <div class="unreadHead">
                      <span class="msgTypeName">{{slotProps.item.typeName}}</span>
                      <button class="msgMarkBtn" v-if="slotProps.item.unReaded"
                        @click="markUnreadMsg(slotProps.item)">标记为已读</button>
                      <span class="msgTimeText" v-else>{{slotProps.item.timeText}}</span>
                    </div>
                    <p class="msgIntro">{{slotProps.item.description}}</p>
                  </div>
                </template>
              </listView>
            </div>
          </transition> -->
        </div>
        <div style="cursor: pointer;height: 48px;padding: 0 10px" class="flexCenter" title="全屏/退出全屏"
          @mouseenter="showPing = true" @mouseleave="showPing = false">
          <img :src="getQuanPingImg" @click="fullScreen()" class="tongyi-img" v-show="!showPing" />
          <img :src="getQuanPingImg1" @click="fullScreen()" class="tongyi-img" v-show="showPing" />
        </div>
        <div style="cursor: pointer;height: 48px;padding: 0 10px" class="flexCenter" title="切换主题风格"
          @mouseenter="showTheme = true" @mouseleave="showTheme = false">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img src="../../../assets/unifyImg/theme.png" @click="initAllSkin_fn" class="tongyi-img"
                v-show="!showTheme" />
              <img src="../../../assets/unifyImg/themesel.png" @click="initAllSkin_fn" class="tongyi-img"
                v-show="showTheme" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(e,i) in tableData" :key="i" :command="e.name">{{e.name}} <span
                  class="color-span" :style="{backgroundColor:e.color}"></span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
        <div class="leftPartImg" @mouseenter="shouMenus = true" @mouseleave="shouMenus = false">

          <!-- <img src="../../../assets/unifyImg/descending.png" alt="" :class="['user-arrow',{'arrow-active':shouMenus}]"> -->
          <!-- <img :src="getUserSelectImg" class="userSelect" alt="" /> -->
          <el-dropdown @command="handleCommand2">
            <span class="el-dropdown-link">
              <img v-if="img" :src="img" class="user tongyi-img"
                style="border-radius: 50%;width: 24px;height: 24px;    object-fit: cover;" />
              <img v-else :src="getUserImg" class="user tongyi-img" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" disabled><span class="userName">用户{{userName}}</span></el-dropdown-item>
              <el-dropdown-item command="4"><span class="userName">更换头像</span></el-dropdown-item>
              <el-dropdown-item command="2">修改密码 <span class="el-icon-key"
                  style=" transform: rotate(45deg); font-size: 15px; font-weight: bold;"></span></el-dropdown-item>
              <el-dropdown-item command="3">退出登陆<img :src="getExitImg"
                  style="transform: translate(0, 2px);" /></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </div>
    </div>

    <el-dialog v-dialogDrag title="更换头像" :visible.sync="dialogVisible" :close-on-click-modal='false' append-to-body
      width="400px">
      <div>

        <el-upload action="" drag :show-file-list="false" :auto-upload="false" accept="image/*" list-type="picture-card"
          :on-change="icon_fn">
          <el-image v-if="imageUrl" :src="imageUrl" class="avatar"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>

    <tianjinTopMenu v-if="enable && tianjin"></tianjinTopMenu>
    <airportTopMenu v-if="enable && AirportTopMenuFlag"></airportTopMenu>

  </div>
</template>

<script>
  import request from "@/api/http.js";
  import unitTree from '@/components/module/tree/unitTree.vue'
  import menuStore from '@/cache/menuStore.js'
  import cacheStore from '@/cache/cacheStore.js'
  import resourcesStore from '@/cache/resourcesStore.js'
  import updatePSWDialog from '@/components/module/dialog/updatePSWDialog.vue'
  import listView from '@/components/module/selection/base/listView.vue'
  import elUnitTree from '@/components/module/tree/elUnitTree.vue'
  import elUnitTreeArea from '@/components/module/tree/elUnitTreeArea.vue'
  import tianjinTopMenu from "@/components/module/menu/tianjinTopMenu.vue"
  import airportTopMenu from "@/components/module/menu/airportTopMenu.vue"
  // import themePop from "@/components/module/menu/themePop.vue"
  import {getNowLogo} from "../../../api/abbNewApi"
  export default {
    components: {
      unitTree,
      listView,
      elUnitTree,
      tianjinTopMenu,
      airportTopMenu,
      elUnitTreeArea,
      // themePop
    },
    props: [],
    data () {
      return {
        imageUrl: '',//上传图片
        dialogVisible: false,//上传图片 弹窗
        loading: false,
        img: '',//头像图片
        tableData: [
          {
            color: '#368ED9',
            name: '科技蓝'
          },{
            color: '#6284DC',
            name: '活力紫'
          },{
            color: '#57585f',
            name: '经典黑'
          },{
            color: '#4885de',
            name: '天空蓝'
          },{
            color: '#2A8E7C',
            name: '国网绿'
          }
        ],
        cityDetail: {},
        cityWearter: undefined,
        drawerFlag: false,
        arrowImg: "",
        buildingValue: "",
        buildingData: null,
        editPasswordImg: false,
        exitImg: false,
        shouMenu: false,
        shouMenus: false,
        areaTree: false,
        isFull: false,
        nowTime: '',
        companyTitle: '',
        nowWeek: '',
        showMsg: false,
        showPing: false,
        showTheme: false,
        filterName: "",
        filterStatus: false,
        weatherIsShow: false,
        newweatherIsShow: false,

        newLogo: [],
        liIndex: 0,
        liData: [
          {
            router: "/comprehensive",
            name: "综合看板"
          },
          {
            router: "/statistics",
            name: "数据统计"
          },
          {
            router: "/abnormal",
            name: "报警及异常处理"
          },
          {
            router: "/monitoringReport",
            name: "监测报告"
          }
        ],
        tianjin: false,
        AirportTopMenuFlag: false,
        isCollapse: false,
        setIntervalTimer: null,


      }
    },
    created () {
      if(DWSystemSetting.companyTitle!=undefined) {
        this.companyTitle=DWSystemSetting.companyTitle;
      } else {
        this.companyTitle='';
      }
    },
    mounted () {
      // 获取头像
      request({url: "/user/getUserPhoto",method: "get"}).then(res => {
        if(res.code=200) {
          this.img=res.data;
        }
      })
      debugPage=this
      var weekday=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
      var now=new Date()
      addNewTask('refreshNowTime',0,1000,-1,() => {
        now.setTime(Date.now())
        this.nowTime=now.formatByTime('-')
        this.nowWeek=weekday[now.getDay()]
        if(!isempty(DWSystemSetting.theWeather)) {
          this.weatherIsShow=DWSystemSetting.theWeather
        }
      })
      this.arrowImg=localStorage.getItem('themeName')
      this.getEnergyLossFlowByUnitId()
      var that=this
      this.setIntervalTimer=setInterval(function() {
        that.getEnergyLossFlowByUnitId()
      },1800000)  //每隔一秒钟打印出111

      this.getNowLogo_fn()

    },
    destroyed () {
      clearInterval(this.setIntervalTimer)
    },
    beforeDestroy () {
      clearInterval(this.setIntervalTimer)
    },
    computed: {
      // getUnitTreeList(){
      //   var data = this.$store.unitStore.getters.getUnitTree
      // 	return isempty(data) ? [] : [unitList(data)]
      // },
      bookmark () {
        return menuStore.state.bookmark
      },
      getNewLogo () {
        return this.$store.deviceStore.state.logoNum
      },
      nowWeLogo () {
        return this.$store.cacheStore.state.nowWeLogo
      },
      socketSate () {
        return this.$store.cacheStore.state.socketState
      },
      socketStateColor () {
        return this.socketSate? {
          'color': '#2bb339'
        }:{
          'color': '#c85050'
        }
      },
      weatherImg () {
        return type => {
          return this.getResourcesByName('weather/'+type+'.png')
        }
      },
      weatherWendu () {
        return wendu => {
          return wendu.split(' ')[1]
        }
      },
      weather () {
        // console.log("天气",this.$store.cacheStore.state.weather);

        return this.$store.cacheStore.state.weather
      },
      userName () {
        var userInfo=this.$store.userStore.state.nowUserInfo
        return userInfo.username
      },
      getColorById () {
        return id => {
          return resourcesStore.getters.getColorById(id)
        }
      },
      getEditPasswordImg () {
        if(this.editPasswordImg) {
          return this.getResourcesByName('topMenu/editPasswordClick.png')
        }
        return this.getResourcesByName('topMenu/editPassword.png')
      },
      getExitImg () {
        if(this.exitImg) {
          return this.getResourcesByName('topMenu/exitClick.png')
        }
        return this.getResourcesByName('topMenu/exit.png')
      },
      getUserImg () {
        if(!this.shouMenus) {
          return this.getResourcesByName('topMenu/user.png')
        }
        return this.getResourcesByName('topMenu/userClick.png')
      },
      getUserSelectImg () {
        if(!this.shouMenus) {
          return this.getResourcesByName('topMenu/userSelect.png')
        }
        return this.getResourcesByName('topMenu/userSelectClick.png')
      },
      getQuanPingImg () {
        if(this.isFull) {
          return this.getResourcesByName('suoxiao.png') //缩小

        } else {
          return this.getResourcesByName('quanping1.png')
        }
      },
      getQuanPingImg1 () {
        if(this.isFull) {
          return this.getResourcesByName('suoxiaosel.png') //缩小

        } else {
          return this.getResourcesByName('quanpingsel.png')
        }
      },
      getUrl () {
        return this.$route.path.indexOf('usePowerUnit')!==-1
      },
      enable () {
        return menuStore.state.showTopMenu
      },
      getBackgroudImageStyle () {
        return resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {

        return resourcesStore.getters.getResourcesByName
      },
      title () {
        if(this.$store.cacheStore.getters.getWebConfig.Title==undefined) {
          return ''
        }
        return this.$store.cacheStore.getters.getWebConfig.Title.split(';')[0]
      },
      logoFile () {
        //debugger

        let img=''
        if((DWSystemSetting.logDingZhi!=undefined&&DWSystemSetting.companyName!=undefined)&&!isempty(DWSystemSetting.logDingZhi[DWSystemSetting.companyName])) {
          if(!isempty(DWSystemSetting.logDingZhi[this.nowUnit.name])) {
            img=DWSystemSetting.logDingZhi[this.nowUnit.name]
          }
        } else {
          if(isempty(this.$store.cacheStore.getters.getWebConfig.LogoFile)) {
            img=""
          } else {
            img='data:image/png;base64,'+this.$store.cacheStore.getters.getWebConfig.LogoFile
          }
        }
        return img
      },
      nowUnit () {
        this.filterName=this.$store.unitStore.getters.getNowUnit.name
        return this.$store.unitStore.getters.getNowUnit
      },
      nowArea () {
        var areaName=this.$store.cacheStore.state.setBuilding
        return areaName==''? '请选择区域':areaName.name
      },
      msgList () {
        //只保留最新的100条消息，而且刷新就移除

        var list=this.$store.socketStore.state.msgList.filter((item,index) => index<100)
        // console.log("未读信息",list);
        if(isempty(list)) {
          list.push({
            type: 'tips',
            name: '没有更多消息了'
          })
        }

        if(this.filterStatus) {
          return list.filter(item => {
            return item.hasOwnProperty('unReaded')
          })
        } else {

          return list
        }
      },
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree
        return isempty(data)? []:[unitList(data)]
      },
      unitList () {
        if(this.dataList.length==0) {
          return []
        }
        return treeToList(this.dataList[0],'children',item => item.hasOwnProperty('children'))
      },
      unitList () {
        //单位列表

        var list=this.$store.unitStore.getters.getUnitList
        //过滤出当前输入的

        if(!isempty(this.filterName)) {
          list=list.filter(item => item.name.includes(this.filterName))
        }
        if(isempty(list)) {
          return [{
            type: 'tips',
            name: '---- 匹配不到任何单位名称 ----'
          }]
        }
        return list
      },
      filterIco () {
        return isempty(this.filterName)? this.getResourcesByName('topMenu/search.png'):this.getResourcesByName('topMenu/close.png')
      },
      // 当前存在未读消息计算

      existMsg () {
        for(var i=this.msgList.length-1;i>=0;i--) {
          if(this.msgList[i].hasOwnProperty('unReaded')) {
            return true
          }
        }
        return false
      },
      // 当前未读消息的个数

      unReadNum () {
        var total=0;
        for(var i=0;i<this.msgList.length;i++) {
          if(this.msgList[i].hasOwnProperty('unReaded')) {
            total++
          }
        }
        return total
      },


      getAirportTopMenu () {
        return this.$store.menuStore.state.airportTopMenu
      },


    },
    watch: {

      getAirportTopMenu: function(val) {
        this.AirportTopMenuFlag=val
      },

      isCollapse (val) {
        this.$store.cacheStore.commit("setIsCollapse",val)
      },
      nowWeLogo () {
        this.getNowLogo_fn()
      },
      bookmark () {},
      getNewLogo (val) {

        if(!val) {
          this.getNowLogo_fn()
        }
      },

    },
    methods: {
      //上传自定义图标
      icon_fn (file) {
        // this.imageUrl=URL.createObjectURL(file.raw);
        //  图片转换base64格式
        var reader=new FileReader();
        reader.readAsDataURL(file.raw)
        reader.onload=(e) => {
          this.imageUrl=e.target.result;
        }
      },
      // 确认上传头像
      finish () {
        if(!this.imageUrl) {
          this.$message({message: '请点击或拖动上传图片',type: 'info'});
          return
        }
        var data=this.imageUrl;
        // 获取头像 0
        request({url: "/user/updatePhoto",method: "post",data}).then(res => {
          if(res.code=200) {
            this.$message({message: res.data,type: 'success'});
            request({url: "/user/getUserPhoto",method: "get"}).then(res => {
              if(res.code=200) {
                this.img=res.data;
                this.dialogVisible=false;
              }
            })
          }
        })

      },
      handleCommand2 (v) {
        if(v==2) {
          this.updatePSW()
        }
        if(v==3) {
          this.logout()
        }
        if(v==4) {
          this.dialogVisible=true;
        }
      },
      // 切换风格

      handleCommand (v) {
        var userDetailed=JSON.parse(localStorage.getItem("userDetailed"))
        var skinArr=JSON.parse(localStorage.getItem("skinArr"))
        var index=skinArr.findIndex(item => item.userId==userDetailed.userId)
        skinArr[index].skinName=v
        localStorage.setItem("skinArr",JSON.stringify(skinArr));

        localStorage.setItem('themeName',v)
        window.location.reload();
      },
      //切换书签栏

      bookmark_fn () {
        menuStore.commit('setBookmark',!this.bookmark)
      },
      //点击跳转到logo配置页面

      logoPage () {
        this.$router.push('/logoConfiguration')
      },
      //获取当前logo

      getNowLogo_fn () {
        var that=this
        that.newLogo=[]
        setTimeout(() => {
          //  getUnitTree().then(res => {
          var data=this.dataList
          if(data.length!=0) {
            var d={
              'unitId': data[0].id
            }
            getNowLogo(d).then(resss => {
              if(resss.code==200) {
                that.newLogo=[resss.data]
              } else {
                that.newLogo=[]
              }
            })
          }

          // })
        },1000)



      },
      //获取定位(百度地图api)

      getEnergyLossFlowByUnitId () {
        var url='https://api.map.baidu.com/location/ip?ak=kfBEh7sKp6UDjQhOeimeYzG46MCGMRkO&coor=bd09ll'
        this.$jsonp(url).then(res => {
          this.cityDetail=res.content
          this.getWeather_fn()
        })
      },
      //根据城市编码获取天气(高德地图api)

      getWeather_fn () {
        var url=`https://restapi.amap.com/v3/weather/weatherInfo?city=${this.cityDetail.address_detail.adcode}&key=cbf8a5676ce61af16277dc07b9666c18`
        this.$jsonp(url).then(res => {
          localStorage.setItem('Weather',JSON.stringify(res.lives[0]))
          this.cityWearter=res.lives[0]
          this.newweatherIsShow=true
        })
      },
      //切换主题

      initAllSkin_fn () {
        this.drawerFlag=!this.drawerFlag
        // localStorage.setItem("themeName",'魅力红')

        // console.log();

      },
      ziZuJian_fn (val) {
        this.drawerFlag=val
      },
      // 切换建筑类型

      select_fn (val) {
        this.$store.cacheStore.commit("setBuilding",val)
      },
      checkItem (item) {
        this.$store.unitStore.commit("setNowUnit",item.id)
        this.$store.unitStore.commit("setUnitGroupNo",item.id)
      },
      updatePSW () {
        //修改密码

        this.shouMenus=false
        var dialogVM=this.$dialogMethod.createDialog(updatePSWDialog)
        dialogVM.show()
      },
      logout () {
        this.shouMenus=false
        this.tianjin=false
        this.$store.menuStore.commit('clear')
        this.$dialogMethod.showLoading("正在注销...")
        this.$api.userApi.logout(respon => {
          //清理所有缓存

          toLogin()
        })
      },
      // 全屏展示

      fullScreen () {
        if(DWSystemSetting.systemName=='环保用电') {
          this.$router.push('/billboard')
          return
        }
        if(this.isFullscreen()==false) {
          this.isFull=true
          var el=document.documentElement;
          var rfs=el.requestFullScreen||el.webkitRequestFullScreen||el.mozRequestFullScreen||el.msRequestFullscreen;
          if(typeof rfs!="undefined"&&rfs) {
            rfs.call(el);
          };
        } else {
          this.isFull=false
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          if(typeof cfs!="undefined"&&cfs) {
            cfs.call(el);
          }
        }
      },
      // 判断当前是否支持全屏显示

      isFullscreen () {
        return document.fullscreenElement||
          document.msFullscreenElement||
          document.mozFullScreenElement||
          document.webkitFullscreenElement||false;
      },
      // 过滤显示的消息

      filterUnreadMsg () {
        this.filterStatus=!this.filterStatus
      },
      // 标记为已读消息

      markUnreadMsg (item) {
        this.$delete(item,'unReaded')
      }
    }
  }
</script>
<style>
  .jiemian .el-upload--picture-card {}

  .topMenu img {
    object-fit: contain;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #d7d7d7 !important;
    color: #1a1a1a !important;
  }
</style>
<style scoped>
  .cropper-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ul {
    padding: 0 15px;
  }

  .ul .li {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
  }

  .ul .li .r {
    color: #378cd4;
    cursor: pointer;
  }

  .btns {
    width: 300px;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #d7d7d7;
    margin: 0 15px;
  }

  .color-span {
    display: inline-block;
    width: 15px;
    height: 15px;
    transform: translate(5px, 2px);
    color: #1a1a1a;
  }

  .user-arrow {
    width: 20px;
    height: 20px;
  }

  .tongyi-img {
    width: 20px;
    height: 20px;
  }

  .arrow-active {
    transform: rotateZ(180deg);
  }

  .topMenu {
    height: .5rem;
    overflow-y: hidden;
    /* overflow: hidden; */
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .nowUnit-name {
    margin-left: 0.2rem;
    width: 2.14rem;
    height: 30px;
    border: 1px solid #ccc;
    text-align: left;
    line-height: 30px;
    padding: 0px 12px;
    /* margin-left: 5px; */
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nowUnit-name span {
    color: #666666;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nowUnit-name img {
    width: 18px;
    height: 18px;
    transition: 0.5s;
  }

  .nowUnit-active {
    border: 1px solid #409eff;
  }

  .nowUnit-active1 {
    border: 1px solid #fff;
  }

  .nowUnit-active img {
    transform: rotateZ(180deg);
  }

  .nowUnit-active1 img {
    transform: rotateZ(180deg);
  }

  /* 需要转化 */
  .tags-view-container {
    height: 34px;
    width: calc(100% - 2rem);
    position: absolute;
    top: 48px;
    left: 200px;
    /* margin-left: 200px; */
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
    z-index: 999;

  }

  .tags-view-container .content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
  }

  .sidebar-logo {
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }

  .sidebar-title {
    display: inline-block;
    margin: 0;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    vertical-align: middle;
    margin-left: 10px;
  }

  /* 需要转化结束 */


  .userName {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #1a1a1a;
  }

  .webTitle {
    height: .5rem;
    width: auto;
    text-align: center;
    line-height: .5rem;
    font-size: 21px;
    font-weight: bold;
    width: 500px;
    color: #212529
  }

  .leftPart {
    /* width: calc(50% - 150px); */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* background-color: #2b2f3a; */
    /* background-color: #fff; */
  }

  .leftPart-logo {
    width: 2rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 9px;
    /* background-color: #304156; */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.35s;
    flex-shrink: 0;
  }

  .leftPart-logo-active {
    width: 0.8rem;
  }

  .logo {
    max-width: 185px;
    max-height: 40px;
  }

  .rightPart {
    /* width: calc(50% - 50px); */
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .leftPartImg {
    height: 48px;
    display: flex;
    align-items: center;
    width: 50px;
    /*border-bottom: 2px solid #116af0;*/
  }

  .rightPart .user {
    /* width: auto; */
    margin-left: 10px;
    max-width: 2rem;
    min-width: .2rem;
    /* height: .2rem; */
  }

  .rightPart .userSelect {
    cursor: pointer;
    width: auto;
    max-width: 2rem;
    min-width: .08rem;
    height: .06rem;
    margin-right: 20px;
    margin-top: 11px;
  }

  .unitSelect {
    margin-left: .2rem;
    min-width: 1rem;
    height: 100%;
    /*border-bottom: 2px solid #cce1ff;*/
    height: 48px;
  }

  .unitSelect>div>input {
    width: 150px;
    background: rgba(0, 0, 0, 0);
    border: 0;
    /* border-left: 1px #49649c solid; */
    border: 1px solid #dcdfe6;
    border-radius: 0;
    padding: 5px 10px;
    height: 20px;
    line-height: 20px;
    outline: none;
    margin: 0 10px;
    color: white;
  }

  .userMenu {
    padding-top: .5rem;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
  }

  .unitMenu {
    max-width: 4rem;
    height: 4rem;
    margin-left: .58rem;
    top: 0;
    padding-top: .5rem;
    position: absolute;
    z-index: 99999;
  }

  .unitMenu .elUnitTreeBody {
    width: 2.4rem;
  }

  .unitMenu .readDeviceTreeBody {
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 10px 10px;
  }

  .area-tree {
    position: absolute;
    max-width: 2.5rem;
    height: 4rem;
    /* margin-left: 4rem; */
    /* top: 0; */
    top: 0;
    /* right: 0px; */
    margin-left: 19px;
    padding-top: .5rem;
    z-index: 99999;
    width: 77%;
  }

  .area-tree .elUnitTreeBody {
    width: 2.4rem;
  }

  .area-tree .readDeviceTreeBody {
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 10px 10px;
  }

  .menuItem {
    height: 33px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .05rem .1rem;
    width: auto;
    cursor: pointer;
    background: white;
    border-left: solid .01rem #BABEC2;
    border-right: solid .01rem #BABEC2;
    border-bottom: solid .01rem #BABEC2;
  }

  .menuItem:last-child {
    border-radius: 0 0 .05rem .05rem;
  }

  .menuItem>span {
    text-align: left;
    width: .7rem;
    padding-left: .1rem;
  }

  .tool-class {
    width: 50%;
  }

  .nowTimeBox {
    /*border-bottom: 2px solid #cce1ff;*/
    height: 48px;
    /* color: white; */
    color: #666666;
    line-height: 50px;
    margin-right: 10px;
  }

  .msgDialog {
    position: absolute;
    width: 360px;
    height: 440px;
    background: white;
    z-index: 5;
    top: 50px;
    right: 20px;
    border-radius: 5px;
    border: 1px silver solid;
    z-index: 110;
  }

  .msgDialog>p {
    padding-right: 20px;
    line-height: 40px;
    text-align: right;
    border-bottom: 1px silver solid;
    color: #0092DC;
  }

  /* 修改默认列表样式 */

  .msgDialog>>>ul.list-body {
    border-radius: 0;
  }

  .msgDialog>>>ul.list-body>li {
    padding: 0;
    border-bottom: none;
    background: none;
    cursor: default;
  }

  .msgOperate {
    overflow: hidden;
    padding: 0 24px;
    border-bottom: solid 1px #CCCCCC;
  }

  .msgOperate>button {
    height: 20px;
    box-sizing: border-box;
    margin: 8px 12px;
    color: #0F87DB;
    padding: 0 8px;
    background: #FFFFFF;
    outline: none;
    border: solid 1px #FFFFFF;
    border-radius: 10px;
    cursor: pointer;
  }

  .msgOperate>.isFilter {
    border-color: #0F87DB;

  }

  .isFilter {
    color: #0F87DB;
    background: none;
  }

  .msgOperate>span {
    float: right;
    line-height: 36px;
  }

  .filterDialog {
    position: absolute;
    height: 300px;
    width: 250px;
    background: white;
    top: 50px;
    z-index: 100;
  }

  .unitName {
    max-width: 140px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .existMsg {
    position: absolute;
    left: 5px;
    top: -5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: red;
    color: #FFFFFF;
    font-size: .12rem;
    text-align: center;
    line-height: 20px;
    transform: scale(0.6);
  }

  .unreadMsgInfo {
    padding: 10px 24px 0 24px;
  }

  .unreadHead {
    margin-bottom: 6px;
    overflow: hidden;
  }

  .msgTypeName {
    float: left;
    background: #0582DA;
    line-height: 18px;
    padding: 0 8px;
    border-radius: 8px;
    font-size: .12rem;
    color: #FFFFFF;
  }

  .msgMarkBtn {
    float: right;
    height: 18px;
    box-sizing: border-box;
    border: solid 1px #0F87DB;
    border-radius: 8px;
    font-size: .12rem;
    padding: 0 8px;
    line-height: 16px;
    color: #0F87DB;
    background: #FFFFFF;
    cursor: pointer;
  }

  .msgTimeText {
    float: right;
    line-height: 18px;
    font-size: .12rem;
    color: #0F87DB;
  }

  .msgIntro {
    font-size: .12rem;
    text-indent: 2em;
    padding-bottom: 10px;
    border-bottom: solid 1px #CCCCCC;
    white-space: normal;
  }

  .unReadMsg {
    background-color: #E3EBF1;
  }
</style>